<template>
<v-dialog v-model="dialog" max-width="800px">
  <CourseGroupForm ref="CourseGroupForm"
    @group-created="refresh"
    @group-updated="refresh"
    @group-deleted="refresh">
  </CourseGroupForm>

  <v-dialog v-model="transferDialog" max-width="400px">
    <v-card class="elevation-12">
      <v-toolbar
        color="primary"
        dark
        flat>
        <v-toolbar-title>Select Group</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="12">
            <v-select
              v-model="transferCourseGroup"
              :items="courseGroups"
              item-text="title"
              item-value="id"
              label="Select Group">
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="transferDialog = false">
          Close
        </v-btn>
        <v-btn 
          color="primary"
          @click="doTransfer">
          Transfer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>Edit Groups</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<Preloader text="Loading" v-if="loading" />
      <v-row v-if="!loading">
        <v-col cols="12" md="8"  offset-md="2">
          <v-select
            v-model="selectedCourseGroup"
            @change="getRegistrations"
            :items="courseGroups"
            item-text="title"
            item-value="id"
            label="Group">
          </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <v-data-table class="d-print-only" ref="PrintArea"
            v-model="selectedRegistrations"
            :headers="headers"
            :items="registrations"
            :loading="loading"
            :search="searchTerm"
            :items-per-page="9999"
            :hide-default-footer="true"
            show-select>

            <template v-slot:top>
              <v-container class="d-print-none">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Search"
                      prepend-icon="mdi-magnify"
                      v-model="searchTerm"
                      autocomplete="off"/>
                  </v-col>

                  <v-col cols="12" md="6" class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn class="mr-2" color="primary"
                      :disabled="selectedRegistrations.length <= 0"
                      @click="transfer">
                      <v-icon left small>mdi-content-cut</v-icon>
                      Transfer {{ '(' + (selectedRegistrations.length) + ')' }}
                    </v-btn>
                    <v-btn class="mr-2" color="primary" dark
                      @click="refresh()">
                      <v-icon left small>mdi-refresh</v-icon>
                      Refresh
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>        
                <!-- <v-divider
                class="mx-4"
                inset
                vertical
                ></v-divider> -->
            </template>
            
            <template v-slot:item._address="{ item }">
              {{ item.city }}, {{ item.barangay }}
            </template>

          </v-data-table>
        </v-col>
      </v-row>
		</v-card-text>
		<v-card-actions>
      <v-btn text color="primary"
        class="ma-0" :disabled="!selectedCourseGroup"
        @click="deleteGroup">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-btn text color="primary"
        class="ma-0" :disabled="!selectedCourseGroup"
        @click="updateGroup">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
			<v-spacer />
			<v-btn 
				color="primary" :disabled="loading"
				@click="createGroup">
				New Group
			</v-btn>
			<v-btn 
				@click="dialog = false">
				Close
			</v-btn>
		</v-card-actions>
  </v-card>
	
</v-dialog> 
</template>
<script>
import Moment from 'moment'
import Api from '../../../services/api'
import CourseMixin from '../../../mixins/course.mixin'
import Notify from '../../../services/notify'
import Preloader from '../../main/Preloader'
import CourseGroupForm from './CourseGroupForm'
import { REGISTRATION_STATUS } from '../../../services/constants'

export default {
  name: 'GroupEditor',
  mixins: [ CourseMixin ],
  components: { Preloader, CourseGroupForm },
  props: [ 'courseId' ],
  data() {
    return {
      loading: false,
      dialog: false,
      transferDialog: false,
      registrations: [],
      selectedRegistrations: [], 
      transferCourseGroup: null,
      course: null,
      searchTerm: null,
      headers: [
        { text: 'Lastname', value: 'lastname', align: 'start' },
        { text: 'Firstname', value: 'firstname' },
        { text: 'Middlename', value: 'middlename' },
        { text: 'Address', value: '_address' },
        { text: 'Mobile', value: 'mobile' },
      ]
    }
  },
  mounted() {
    // this.refreshCourses();
  },
  methods: {
    init() {
      this.dialog = true;
      this.loading = true;
      this.refresh();
    },

    refresh() {
      if(this.courseId) {
        this.loading = true;
        this.getCourseGroups(this.courseId)
          .then(() => {
            this.loading = false;
            this.getRegistrations();
          });
      }
    },

    getRegistrations() {
      this.loading = true;
      this.selectedRegistrations = [];
      Api.registration.getAll(
        Moment('2020-01-01').format('YYYY-MM-DD'),
        Moment().startOf('endOf').format('YYYY-MM-DD'),
        null,
        this.selectedCourseGroup,
        this.courseId,
        REGISTRATION_STATUS.ENROLLED
      )
        .then((response) => {
          this.registrations = response.data;
        })
        .finally(() => { this.loading = false; });
    },

    createGroup() {
      this.$refs.CourseGroupForm.create(this.courseId);
    },

    updateGroup() {
      this.$refs.CourseGroupForm.update(this.selectedCourseGroup);
    },

    deleteGroup() {
      this.$refs.CourseGroupForm.delete(this.selectedCourseGroup);
    },

    transfer() {
      this.transferDialog = true;
    },

    doTransfer() {
      this.transferDialog = false;
      Api.registration.bulkGroupTransfer(this.transferCourseGroup, this.selectedRegistrations)
        .then(() => {
          Notify.success.actionSuccess();
        })
        .finally(() => { this.refresh() });
    }

  }
}
</script>